<template>
  <font-awesome-icon
    v-if="!$store.state.$account"
    icon="circle-notch"
    spin
    class="aling-middle text-moremuted fa-2x"
  />

  <AppHeaderDropdown v-else :right="$dir.ltr" no-caret>
    <template slot="header">
      <thumbnail
        v-if="$store.state.$account.image"
        :path="$store.state.$account.image"
        :link="false"
        :width="28"
        :height="28"
        class="rounded-circle"
      />

      <font-awesome-icon
        v-else
        icon="user-circle"
        class="align-middle fa-2x"
      />
    </template>

    <template slot="dropdown">
      <b-dropdown-header tag="div" class="text-center">
        <strong>
          {{ $t('account.account') }}
        </strong>
      </b-dropdown-header>

      <b-dropdown-item to='/account/profile'>
        <i>
          <font-awesome-icon icon="user" class="align-middle"/>
        </i>
        {{ $t('account.profile') }}
      </b-dropdown-item>

      <b-dropdown-divider class="my-0"/>

      <b-dropdown-item to='/account/change-email'>
        <i>
          <font-awesome-icon icon="envelope" class="align-middle"/>
        </i>
        {{ $t('account.changeEmail') }}
      </b-dropdown-item>

      <b-dropdown-item to='/account/change-phone-number'>
        <i>
          <font-awesome-icon icon="mobile" class="align-middle"/>
        </i>
        {{ $t('account.changePhoneNumber') }}
      </b-dropdown-item>

      <b-dropdown-item v-if="loginViaPasswordEnabled" to='/account/change-password'>
        <i>
          <font-awesome-icon icon="key" class="align-middle"/>
        </i>
        {{ $t('account.changePassword') }}
      </b-dropdown-item>

      <b-dropdown-divider class="my-0"/>

      <b-dropdown-item @click="logout">
        <i>
          <font-awesome-icon icon="power-off" class="text-danger align-middle"/>
        </i>
        {{ $t('account.logout') }}
      </b-dropdown-item>
    </template>
  </AppHeaderDropdown>
</template>

<script>
import vm from '@/vm'
import { HeaderDropdown as AppHeaderDropdown } from './core'
import { Thumbnail } from '@/components/shared'
import Settings from '@/mixins/settings/index'

export default {
  name: 'Account',
  mixins: [Settings],
  components: {
    AppHeaderDropdown,
    Thumbnail
  },
  methods: {
    logout () {
      if (!this.progressing) {
        vm.$emit('logout')
      }
    }
  }
}
</script>
